module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "academic_mentors.a98a11f7.png";